import dayjs from "dayjs";

let api = "";
if (process.env.REACT_APP_API) {
	api = process.env.REACT_APP_API;
} else if (process.env.NODE_ENV === "development") {
	// api = "http://localhost:4121/api";
	api = "http://192.99.21.144:64121/api";
	// api = "http://duesapi.loop3.com.br/api";
	// api = "https://api.dues.com.br/api";
} else {
	api = "";
}

export const serverUrl = api;

export function createRequest(
	url: RequestInfo,
	method: RequestInit["method"],
	body?: any,
	headers: RequestInit["headers"] = {}
) {
	const options: RequestInit = {
		method,
		headers: {
			"content-type": "application/json",
			timezone: dayjs().format("Z"),
			...headers
		}
	};

	if (body) options.body = JSON.stringify(body);

	url = api + url;

	return fetch(url, options);
}

export function sendPost(
	url: RequestInfo,
	body?: any,
	headers?: RequestInit["headers"]
) {
	return createRequest(url, "POST", body, headers);
}

export function sendPut(
	url: RequestInfo,
	body?: any,
	headers?: RequestInit["headers"]
) {
	return createRequest(url, "PUT", body, headers);
}

export function sendGet(url: RequestInfo, headers?: RequestInit["headers"]) {
	return createRequest(url, "GET", null, headers);
}

export function sendDelete(url: RequestInfo, headers?: RequestInit["headers"]) {
	return createRequest(url, "DELETE", null, headers);
}

export function sendPostFile(
	url: RequestInfo,
	file: any,
	headers?: RequestInit["headers"]
) {
	const formData = new FormData();

	if (file) formData.append("file", file);

	const options = {
		method: "POST",
		body: formData,
		headers: {
			// If you add this, upload won't work
			// "Content-Type": "multipart/form-data",
			...headers
		}
	};

	url = api + url;

	return fetch(url, options);
}

export function sendPostFiles(
	url: RequestInfo,
	files: any[],
	headers?: RequestInit["headers"]
) {
	const formData = new FormData();

	for (const file of files) {
		formData.append("files", file);
	}

	const options = {
		method: "POST",
		body: formData,
		headers: {
			// If you add this, upload won't work
			// "Content-Type": "multipart/form-data",
			...headers
		}
	};

	url = api + url;

	return fetch(url, options);
}
